<template>
  <div>
    <div class="sm-compare-list">
      <div ref="fake_scroll" class="fake-scroll">
        <div class="custom-thumb" ref="customThumb"></div>
      </div>
      <div class="list sm-w-full sm-overflow-x-auto">
        <div>
          <div class="sm-column first">
            <div class="item first">
              <h4 v-if="title == 'spherephone addon'">SpherePhone™</h4>
              <h4 v-else-if="title == 'extras'">Additional Services</h4>

              <h4 v-else>{{ title }}</h4>
            </div>
            <div
              v-for="feature in features"
              :key="feature.field"
              class="item"
              :title="feature.title"
              v-if="feature.hidden != 'customer' && feature.hidden != 'legacy'"
            >
              <span class="sm-text-truncate">{{ feature.title }}</span>
              <hint-wrap
                class="sm-inline-block sm-ml-4"
                v-if="feature.customer?.title"
                :text="feature.customer.title"
                :left="true"
              >
                <template slot="content">
                  <include-svg :name="'icon-hint'" />
                </template>
              </hint-wrap>
            </div>
            <div class="item" v-if="btnsProps && !['extraTiny', 'tiny', 'small'].includes(viewPort)">
            </div>
          </div>
          <div ref="list" class="sm-grid sm-grid-cols-auto hide-scrollbar">
            <div
              class="sm-column"
              v-for="(plan,index) in plansWithFeatures"
              :key="plan.id"
            >
              <div class="item first">
                <span class="sm-h6">{{ plan.title }}</span>
              </div>
              <div
                v-for="feature in features"
                :key="feature.field"
                v-if="feature.hidden != 'customer' && feature.hidden != 'legacy'"
                class="item"
                :class="{
                  'sm-text-xl sm-font-bold': plan.features[feature.field]?.unlimited,
                  'sm-justify-start! sm-pl-20! sm-text-left!':
                    feature.field == 'conf_room_discount_amount' &&
                    plan.conference_rooms.length,
                  'sm-flex-1': feature.field == 'conf_room_discount_amount',
                }"
              >
                <template v-if="feature.field !== 'conf_room_discount_amount'">
                  <template v-if="plan.features[feature.field]?.type == 'boolean'">
                    <include-svg
                      v-if="plan[feature.field]"
                      :name="'icon-check'"
                      class="sm-text-green sm-size-4!"
                    />
                    <include-svg
                      v-else
                      :name="'icon-action-close'"
                      class="sm-text-grey sm-size-5!"
                    />
                  </template>
                  <template v-else>
                    {{ proceedingCellContent(feature, plan) }}
                  </template>
                </template>
                <template v-else>
                  <template v-if="plan.conference_rooms?.length">
                    <div class="sm-flex sm-flex-column sm-gap-8">
                      <template v-for="room in plan.conference_rooms">
                        <div class="sm-flex sm-flex-column">
                          <span>{{ room.name }}</span>
                          <span class="sm-font-semibold sm-text-error">
                            <template v-if="room.discount_amount">$</template>
                            {{ room.discount || room.discount_amount }}
                            <template v-if="room.discount">%</template>
                          </span>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                    <include-svg
                      :name="'icon-action-close'"
                      class="sm-text-grey sm-size-5!"
                    />
                  </template>
                </template>
              </div>
              <slot name="end-rows"></slot>
              <div class="item price" v-if="btnsProps && !['extraTiny', 'tiny', 'small'].includes(viewPort)">
                <div class="sm-flex sm-flex-column sm-items-center">
                  <div class="sm-flex sm-items-center">
                    <p class="sm-text-primary sm-font-black">
                      <template v-if="btnsProps?.period == 'monthly'">
                        {{ formatPrice(plan.subscription_price) }}
                      </template>
                      <template v-else-if="btnsProps?.period == 'yearly'">
                        {{ formatPrice(plan.period_amount / 12) }}
                      </template>
                      <template v-else>
                        {{ formatPrice(plan.period_amount / 6) }}
                      </template>
                    </p>
                    <span class="sm-text-sm sm-text-grey-4">/month</span>
                  </div>
                  <div class="sm-flex sm-items-center">
                    <btn-block
                      v-if="!btnsProps?.currentPlanId"
                      :classes="[
                        'btn',
                        index != 1 ? 'btn-outlined' : ''
                      ]"
                      :text="btnsProps?.btnText"
                      @click="selectPlan(plan)"
                    />
                    <btn-block
                      v-else
                      :class="{
                        disabled:
                          plan.id == btnsProps.currentPlanId &&
                          btnsProps.period == btnsProps.currentPlanTerm,
                      }"
                      :classes="[
                        'btn',
                        plan.id == btnsProps.currentPlanId ? '' : 'btn-outlined',
                      ]"
                      :text="btnsProps?.getBtnText(plan)"
                      @click="selectPlan(plan)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HintWrap from '@/components/HintWrap.vue';
import ViewPort from '@/mixins/ViewPort.vue';
import { FormatPrice } from '@/utils/general-data';

export default {
  name: 'compare-table',
  components: {
    'hint-wrap': HintWrap,
  },
  mixins: [ViewPort],
  props: {
    title: {
      type: String,
      required: true,
    },
    plans: {
      type: Array,
      required: true,
    },
    features: {
      type: Array,
      required: true,
    },
    btnsProps: {
      type: Object,
      default: null,
    },
  },
  computed: {
    plansWithFeatures() {
      let plans = [];
      this.plans.map(plan => {
        let tempPlan = { ...plan };
        tempPlan.features = {};
        this.features.forEach(feat => {
          let feature = { ...feat };
          tempPlan.features[feature.field] = feature;

          if (!plan.hasOwnProperty(feature.field)) {
            if (!feature.alt_field || plan.hasOwnProperty(feature.alt_field))
              return;
          }

          if (feature.enable_field && !plan[feature.enable_field]) return;

          if (feature.hidden == 'legacy' || feature.hidden == 'customer')
            return;

          if (
            feature.ref_from &&
            plan[feature.field] == 0 &&
            plan[feature.ref_from] == 0
          )
            return;

          if (
            feature.ref_to &&
            plan[feature.field] == 0 &&
            plan[feature.ref_to] == 0
          )
            feature.unlimited = true;

          feature.value = plan[feature.field];
          feature.alt_value = feature.alt_field
            ? plan[feature.alt_field]
            : null;
          feature.flag = feature.flag_field ? plan[feature.flag_field] : false;
          feature.available =
            !feature.available_field ||
            !plan.hasOwnProperty(feature.available_field) ||
            plan[feature.available_field]
              ? true
              : false;

          if (feature.customer)
            Object.keys(feature.customer).forEach(
              key => (feature[key] = feature.customer[key])
            );
        });
        plans.push(tempPlan);
      });
      return plans;
    },
  },
  methods: {
    formatPrice: FormatPrice,
    proceedingCellContent(feature, plan) {
      let value = plan.features[feature.field].value;
      let alt_value = plan.features[feature.field].alt_value;
      if (plan.features[feature.field].available == false) {
        return 'N/A';
      }
      if (plan.features[feature.field].unlimited) {
        return '∞';
      }
      if (feature.type == 'price') {
        value = this.formatPrice(value);
      } else if (feature.type == 'flagged') {
        value = plan.features[feature.field].flag
          ? this.formatPrice(value)
          : value + '%';
      } else if (feature.type == 'mixed') {
        if (value && value !== 0) value = this.formatPrice(value);
        else if (alt_value) value = value + '%';
        else value = 0;
      } else if (feature.type == 'raw') {
        value = value;
      } else {
        value = `${value} ${feature.type}`;
      }
      return value ? value : '-';
    },
    handleScrollWidth() {
      const list = this.$refs.list;
      const track = this.$refs.fake_scroll;
      const thumb = this.$refs.customThumb;
      // Align track with list left
      track.style.left = (list.offsetLeft + 4) + 'px';
      // Track should match list visible width
      track.style.width = list.clientWidth + "px";

      // Calculate thumb width
      const visibleRatio = list.clientWidth / list.scrollWidth;
      const thumbWidth = Math.max(visibleRatio * track.clientWidth, 30); // min width
      thumb.style.width = thumbWidth + "px";

      // Update position immediately in case resize changed things
      this.handleScrollPosition();
    },
    handleScrollPosition() {
      const list = this.$refs.list;
    const track = this.$refs.fake_scroll;
    const thumb = this.$refs.customThumb;

    const thumbWidth = thumb.offsetWidth;
    const maxThumbLeft = track.clientWidth - thumbWidth;

    // Map scrollLeft to track space
    const scrollRatio = list.scrollLeft / (list.scrollWidth - list.clientWidth);
    const thumbLeft = scrollRatio * maxThumbLeft;

    thumb.style.left = thumbLeft + "px";
    },
  },
  mounted() {
    this.handleScrollWidth();
    this.$refs.list.addEventListener('scroll', this.handleScrollPosition);
    window.addEventListener('resize', this.handleScrollWidth); 
  },
};
</script>

<style lang="scss">
@use '@/assets/scss/general/mixins.scss' as *;
.sm-compare-list {
  container-type: inline-size;
  container-name: list;
  position: relative;
  --1st-col-width: 280px;
  max-width: 1100px;
  width: 100%;
  margin: auto;
  margin-top: 1.5rem;


  & > .list {
    align-items: center;
    // hide scrollbar
    scrollbar-width: none; // for Firefox
    -ms-overflow-style: none; // for Internet Explorer and Edge
    &::-webkit-scrollbar {
      display: none; // for Chrome, Safari, and Opera
    }

    & > div {
      display: flex;
      width: fit-content;
      max-width: 100%;
    }

    & .sm-grid {
      display: grid;
      grid-auto-flow: column;
      width: max-content;
      overflow-x: auto;
    }
  }
  .sm-column {
    width: 200px;
    display: flex;
    flex-direction: column;
    div.item {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      border: 1px solid #e0e0e0;
      min-height: 64px;
      padding: 0.4rem 0.8rem;
      & h4::first-letter{
        text-transform: uppercase;
      }
      & p {
        font-size: 30px;
        line-height: 2rem;
        margin-bottom: 5px;
      }
      &.first {
        border-left: none;
        border-right: none;
        border-top: none;
      }
      &:last-of-type {
        border-bottom: none;
      }
    }
    &.first {
      left: 0;
      z-index: 10;
      background: color-mix(in srgb, var(--text), white 90%);
      grid-column: auto;
      max-width: var(--1st-col-width);
      width: 100vw;
      div.item {
        justify-content: flex-start;
        text-align: left;
        border-left: none;
        &:last-of-type {
          border-bottom: none;
        }
      }
    }
    &:last-of-type {
      div.item {
        border-right: none;
      }
    }
  }
  @container list (max-width: 1000px) {
    .fake-scroll {
      display: block;
      position: absolute;
      top: 10px;
      left: 0;
      height: 4px;
      overflow: hidden;
      pointer-events: none;
      z-index: 20;
      & .custom-thumb {
        position: absolute;
        height: 100%;
        left: 0;
        background: var(--grey-line-2);
        border-radius: 4px;
        transition: left 0.2s;
      }
    }
  }
  @include media('<small') {
    --1st-col-width: 250px;
    .sm-column div.item.first {
      height: 160px;
    }
    .sm-column:not(.first) {
      width: 120px;
      div.item.first {
        justify-content: center;
        text-align: right;
        & > * {
          transform: rotate(30deg);
          writing-mode: sideways-lr;
          transform-origin: left center;
          white-space: nowrap;
          display: inline-block;
        }
      }
    }
  }
  @include media('<=tiny') {
    --1st-col-width: 150px;
  }
  .hide-scrollbar {
    scrollbar-width: none; // for Firefox
    -ms-overflow-style: none; // for Internet Explorer and Edge
    &::-webkit-scrollbar {
      display: none; // for Chrome, Safari, and Opera
    }
  }
}
</style>
